import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !NO_RETRY.includes(cfg.url)) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("wt-unauthorized"));
      }
    }
    return Promise.reject(error);
  }
);

export function errorText(e, fallback) {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ") || fallback;
  return fallback;
}
